export const stayPromotions = {
  title: "Aufenthaltsangebote",
  description: "Bieten Sie Ihren Gästen Sonderrabatte für längere Aufenthalte",
  newPromotion: "Neues Angebot",
  loading: "Angebote werden geladen...",
  close: "Schließen",
  cancel: "Abbrechen",
  noLimit: "Kein Limit",

  status: {
    active: "Aktiv",
    paused: "Pausiert",
  },

  card: {
    stay: "Aufenthalt",
    discount: "Rabatt",
    validity: "Gültigkeit",
    edit: "Bearbeiten",
    delete: "Löschen",
  },

  nights: {
    range: "{min} - {max} Nächte",
    min: "{min}+ Nächte",
  },

  empty: {
    title: "Keine Angebote eingerichtet",
    description: "Erstellen Sie Angebote, um längere Aufenthalte zu fördern und mehr Buchungen zu erhalten",
    create: "Erstes Angebot erstellen",
  },

  form: {
    editTitle: "Angebot bearbeiten",
    createTitle: "Neues Angebot",
    nameLabel: "Name des Angebots",
    namePlaceholder: "z. B. Rabatt ab 7 Nächten, Wochenangebot",
    minNights: "Mindestanzahl Nächte",
    maxNights: "Höchstanzahl Nächte",
    optional: "(optional)",
    noLimitPlaceholder: "Kein Limit",
    discountType: "Rabattart",
    percentage: "Prozentsatz",
    fixedAmount: "Fester Betrag",
    discountValue: "Rabattwert",
    validFrom: "Gültig ab",
    validTo: "Gültig bis",
    activateNow: "Angebot sofort aktivieren",
    saving: "Wird gespeichert...",
    update: "Aktualisieren",
    create: "Angebot erstellen",
  },

  invoice: {
    title: "Beispiel für die Ersparnis",
    pricePerNight: "Preis pro Nacht",
    numberOfNights: "Anzahl der Nächte",
    subtotal: "Zwischensumme",
    discountApplied: "Angewendeter Rabatt",
    totalToPay: "Gesamtbetrag",
    guestSaves: "Der Gast spart {amount}",
  },

  statusModal: {
    activateTitle: "Angebot aktivieren",
    pauseTitle: "Angebot pausieren",
    activateDescription: 'Möchten Sie das Angebot "{name}" aktivieren, damit es für neue Buchungen gilt?',
    pauseDescription: 'Möchten Sie das Angebot "{name}" pausieren?',
    confirm: "Bestätigen",
  },

  deleteModal: {
    title: "Angebot löschen",
    warningStrong: "Diese Aktion kann nicht rückgängig gemacht werden.",
    warningText: "Stellen Sie vor dem Löschen sicher, dass Sie das Angebot {name} nicht mehr benötigen.",
    confirmLabel: "Geben Sie zur Bestätigung den genauen Namen ein:",
    confirmPlaceholder: "Namen des Angebots exakt eingeben",
    hint: "Fügen Sie den Namen genau so ein, wie er oben steht, um die Schaltfläche zum Löschen freizugeben.",
    deleting: "Wird gelöscht...",
    confirmDelete: "Endgültig löschen",
  },

  toasts: {
    nameRequired: "Bitte geben Sie einen Namen ein",
    minNightsWarning: "Die Mindestanzahl an Nächten muss 1 oder höher sein",
    selectRatePlan: "Wählen Sie einen Basistarif",
    updated: "Angebot aktualisiert",
    created: "Angebot erstellt",
    saveFailed: "Speichern nicht möglich",
    saveError: "Fehler beim Speichern",
    activated: "Angebot aktiviert",
    pausedToast: "Angebot pausiert",
    updateFailed: "Aktualisierung nicht möglich",
    statusError: "Fehler beim Ändern des Status",
    deleted: "Angebot gelöscht",
    deleteFailed: "Löschen nicht möglich",
    deleteError: "Fehler beim Löschen",
  },
};
